import AddProductDetailMasterDialogOrig from "../../../../components/dialog/addProductDetailMasterDialog/AddProductDetailMasterDialog"

export default function AddProductDetailMasterDialog ({isOpen, onClose, addingProduct}) {
  return (
    <AddProductDetailMasterDialogOrig
      open={isOpen}
      onClose={onClose(null)}
      productData={addingProduct}
      openAddProductDialog={(product) => onClose({status: "REOPEN_ADD_PRODUCT", product})()}
    />
  )
}